import { useEffect, useState } from 'react';
import { setNextActiveCharacter } from 'src/utils';

import type { Character, PhraseData, Puzzle } from 'src/types';

interface useDefineCharactersListProps {
  phraseData?: PhraseData;
  phraseNoSpaces?: string;
  scrambledNoSpaces?: string;
  initialPuzzleData?: Puzzle;
  warmupTimer: number;
}

export function useDefineCharactersList({
  phraseData,
  phraseNoSpaces,
  scrambledNoSpaces,
  initialPuzzleData,
  warmupTimer,
}: useDefineCharactersListProps) {
  const [charactersList, setCharactersList] = useState<Character[]>();

  /**
   * Defines the main data-structure that is manipulated all over the game
   */
  useEffect(() => {
    if (phraseNoSpaces && scrambledNoSpaces && !initialPuzzleData) {
      const initialCharactersList = scrambledNoSpaces.split('').reduce((acc, character, key) => {
        return [
          ...acc,
          {
            character,
            isActive: false,
            isPlaced: false,
            currentPosition: {
              x: key,
              y: 0,
            },
            correctPosition: {
              x: phraseNoSpaces.split('').reduce((oAcc, oCharacter, oKey) => {
                if (oCharacter === character) {
                  return [...oAcc, oKey];
                }
                return oAcc;
              }, [] as number[]),
              y: (phraseData?.rows || scrambledNoSpaces.length) - 1,
            },
          },
        ];
      }, [] as Character[]);

      setCharactersList(setNextActiveCharacter(initialCharactersList, false));
    }
  }, [phraseNoSpaces, scrambledNoSpaces, phraseData?.rows]);

  useEffect(() => {
    if (!initialPuzzleData) {
      return;
    }

    setCharactersList(initialPuzzleData.charactersList);
  }, [initialPuzzleData, warmupTimer]);

  return {
    charactersList,
    setCharactersList,
  };
}
